import { useParams } from "react-router-dom";

import { useEvent } from "../../changelog-item-context";
import EntityLink from "../EntityLink";

import EventTitleWrapper, { ActionText } from "./EventTitleWrapper";

import { ActionType, ChangelogEntry, EntityType } from "@/queries";

const RunBatchEventTitle = () => {
  const event = useEvent<ChangelogEntry<ActionType.RUN_BATCH>>();
  const batchName = event.action_payload?.name;
  const { workspaceId } = useParams();

  const link = `/workspace/${workspaceId}/evaluate/blueprints/${event.entity_id}/reports/${event.action_payload?.batch_run_id}`;

  return (
    <EventTitleWrapper>
      <ActionText>New batch run</ActionText>
      <EntityLink type={EntityType.REPORT} name={batchName || "Batch"} link={link} />
      <ActionText>was executed</ActionText>
    </EventTitleWrapper>
  );
};

export default RunBatchEventTitle;
